__turbopack_context__.v({
  "root": "OfficeHoursDetails-module-scss-module__NSBK7q__root",
});
